import React from 'react'

import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps"
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel"
import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer"
import CostumMarker from './CostumMarker';
import { construct } from 'react-google-maps/lib/utils/MapChildHelper';
import { MapStyles } from './MapStyles'

const MyMapComponent = withScriptjs(withGoogleMap((props) =>

    <GoogleMap
        defaultZoom={7.48}
        defaultCenter={{ lat: 42.6, lng: 44 }}
        defaultOptions={{ styles: MapStyles }}
    >

        <MarkerClusterer
            averageCenter
            enableRetinaIcons
            gridSize={60}
        >
            {
                props.markers.map((marker, index) => {
                    return <CostumMarker key={index} marker={marker} icons={props.icons[marker.salesPointType]} />
                }
                )}
        </MarkerClusterer>
    </GoogleMap>

))

export default MyMapComponent



// WEBPACK FOOTER //
// ./src/pages/SalePoints/Map.js